var t,e;function r(){if(e)return t;function r(t){this.message=t}return e=1,r.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},r.prototype.__CANCEL__=!0,t=r}export{r as __require};
